import React from 'react';
import { t } from '@lingui/macro';

import useSnackBar from '@src/hooks/useSnackBar';
import { i18n } from '@src/i18n';

import * as serviceWorker from './serviceWorkerRegistration';
import { Props } from './types';

const ServiceWorker: React.FC<Props> = ({ children }) => {
  const snackBar = useSnackBar();
  const [showReload, setShowReload] = React.useState(false);
  const [
    waitingWorker,
    setWaitingWorker,
  ] = React.useState<ServiceWorker | null>(null);

  const handleSWUpdate = React.useCallback(
    (registration: ServiceWorkerRegistration) => {
      setWaitingWorker(registration.waiting);
      setShowReload(true);
    },
    []
  );

  React.useEffect(() => {
    serviceWorker.register({ onUpdate: handleSWUpdate });
  }, [handleSWUpdate]);

  const handleReload = React.useCallback(() => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShowReload(false);
    window.location.reload();
  }, [waitingWorker]);

  React.useEffect(() => {
    if (showReload) {
      snackBar.show({
        content: `${i18n._(t`A new version is available!`)} v${
          process.env.REACT_APP_VERSION
        }`,
        action: { label: i18n._(t`Reload`), onPress: handleReload },
      });
    }
  }, [handleReload, showReload, snackBar]);

  return <>{children}</>;
};

export default ServiceWorker;
